module.exports = __webpack_public_path__ + "static/aikiishinryu02light-a5aa17ddc2365591e820d382810b120a.mp4";